/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurveyHeaders from './survey-headers';
import SurveyHeadersDetail from './survey-headers-detail';
import SurveyHeadersUpdate from './survey-headers-update';
import SurveyHeadersDeleteDialog from './survey-headers-delete-dialog';

const SurveyHeadersRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurveyHeaders />} />
    <Route path="new" element={<SurveyHeadersUpdate />} />
    <Route path=":id">
      <Route index element={<SurveyHeadersDetail />} />
      <Route path="edit" element={<SurveyHeadersUpdate />} />
      <Route path="delete" element={<SurveyHeadersDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurveyHeadersRoutes;
